import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLd?: object | object[];
}

const SITE_URL = 'https://uncutm.github.io';

export default function Seo({ title, description, keywords, canonical, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    const ensure = (selector: string, attr: string, value: string, create?: () => HTMLElement) => {
      let el = document.head.querySelector<HTMLElement>(selector);
      if (!el) {
        el = create ? create() : document.createElement('meta');
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    ensure('meta[name="description"]', 'content', description, () => {
      const m = document.createElement('meta');
      m.name = 'description';
      return m;
    });
    if (keywords) {
      ensure('meta[name="keywords"]', 'content', keywords, () => {
        const m = document.createElement('meta');
        m.name = 'keywords';
        return m;
      });
    }
    ensure('link[rel="canonical"]', 'href', canonical ?? SITE_URL, () => {
      const l = document.createElement('link');
      l.rel = 'canonical';
      return l;
    });
    ensure('meta[property="og:title"]', 'content', title);
    ensure('meta[property="og:description"]', 'content', description);
    ensure('meta[property="og:url"]', 'content', canonical ?? SITE_URL);
    ensure('meta[name="twitter:title"]', 'content', title);
    ensure('meta[name="twitter:description"]', 'content', description);

    document.querySelectorAll('script[data-seo-jsonld]').forEach((s) => s.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((item) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-jsonld', 'true');
        script.textContent = JSON.stringify(item);
        document.head.appendChild(script);
      });
    }
  }, [title, description, keywords, canonical, jsonLd]);

  return null;
}